import { Eyebrow, Reveal } from "./Reveal";

const STEPS = [
  {
    n: "1",
    title: "Create your profile",
    body: "Add your photos, profession and a little about you. Optionally verify your healthcare credentials.",
  },
  {
    n: "2",
    title: "Discover & match",
    body: "Swipe through other healthcare professionals. When you both like each other, it's a match.",
  },
  {
    n: "3",
    title: "Start the conversation",
    body: "Message your matches and find someone who truly understands the life behind the credentials.",
  },
];

export const HowItWorks = () => (
  <section
    id="how"
    data-testid="how-it-works-section"
    className="bg-[linear-gradient(135deg,#EEF5F1_0%,#F6EFE8_100%)] py-28 sm:py-36"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mx-auto max-w-2xl text-center">
        <Eyebrow>How it works</Eyebrow>
        <h2 className="mt-5 font-editorial text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
          Three steps to{" "}
          <span className="font-normal italic text-terracotta-dark">your person</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div
              data-testid={`how-step-${i}`}
              className="group h-full rounded-[24px] border border-hairline bg-cream p-8 shadow-[0_20px_45px_-35px_rgba(36,26,22,0.35)] transition-transform duration-500 hover:-translate-y-1.5"
            >
              <div className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-terracotta font-editorial text-lg italic text-white shadow-[0_12px_25px_-10px_rgba(224,122,95,0.8)] transition-transform duration-500 group-hover:scale-110 group-hover:-rotate-6">
                {s.n}
              </div>
              <h3 className="mt-6 text-lg font-extrabold tracking-tight">{s.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-clay">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
